import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import B2becCustomSelect from '@/components/B2becCustomSelect'
import { useAppSelector } from '@/store/hook'
import {
  selectAvailableLanguages,
  selectInitialLangCode,
  selectIsChangingLanguage,
  selectIsFetchingUserConfigurations,
} from '@/store/selectors/userSelector'
import usePermission from '@/hooks/usePermission'
import { MODULE_PROFILE_RIGHTS } from '@/libs/constants/modulerights'

const LanguageBlock = ({ onChangeLanguage }) => {
  const { t } = useTranslation()

  const isFetchingUserConfigurations = useAppSelector(
    selectIsFetchingUserConfigurations,
  )
  const isChangingLanguage = useAppSelector(selectIsChangingLanguage)
  const availableLanguages = useAppSelector(selectAvailableLanguages)
  const initialLangCode = useAppSelector(selectInitialLangCode)

  const [selectedLanguage, setSelectedLanguage] = useState(
    () => initialLangCode,
  )
  const { hasPermission: hasChangeLanguagePermission } = usePermission(
    MODULE_PROFILE_RIGHTS.CHANGE_LANGUAGE,
  )
  const canDisableButton = isFetchingUserConfigurations
    || isChangingLanguage
    || !hasChangeLanguagePermission

  const selectedValue = useMemo(() => {
    const matchedLang = availableLanguages.find(
      (item) => item?.value === selectedLanguage,
    )
    if (!matchedLang?.value) {
      return ''
    }
    return selectedLanguage
  }, [availableLanguages, selectedLanguage])

  const handleChange = useCallback(
    (newLanguage) => {
      onChangeLanguage(newLanguage, initialLangCode)
      setSelectedLanguage(newLanguage)
    },
    [onChangeLanguage, initialLangCode],
  )

  return (
    <div className="profile__main-block">
      <div className="profile__main-block__label">
        {t('myProfile.changeLanguage')}
      </div>

      <div className="profile__main-block__description mb-4">
        {t('myProfile.LanguageDesc')}
      </div>

      <B2becCustomSelect
        disabled={canDisableButton}
        loading={canDisableButton}
        options={availableLanguages}
        style={{ width: 234 }}
        value={selectedValue}
        onChange={handleChange}
      />
    </div>
  )
}

export default LanguageBlock
